import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import HumanResourcesContainer from 'app/containers/HumanResources'

const HumanResourcesPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.hr)}</PageTitle>
      <HumanResourcesContainer />
    </>
  )
}
const HumanResourcesPage = memo(HumanResourcesPageCpn, isEqual)

export default HumanResourcesPage
